<div class="p-20" fxLayout="column" fxLayoutAlign="start stretch">

  <ng-container *ngIf="productoSeleccionado == 0">
    <div class="mb-40" fxLayout="row" fxLayoutAlign="center stretch">
      <div class="statusDiv" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div class="roundEdg primary mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'GESTORSTATUS.PRODSINFO.SELECCIONE' | translate}}</h2>
          <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="productoSeleccionado != 0">
    <div class="" fxLayoutAlign="row" fxLayoutAlign="center stretch">

      <div class="" fxFlex="50" fxLayout="column" fxLayoutAlign="start stretch">

        <div class="mat-elevation-z2 pl-20 pr-20" fxLayout="row" fxLayoutAlign="space-between center">
          <div class="" fxFlex="70">
            <h2>{{'GESTORSTATUS.STATUS.LISTA' | translate}}</h2>
          </div>
          <div class="" fxFlex="30" fxLayout="row" fxLayoutAlign="space-between center">
            <h2>{{'GESTORSTATUS.STATUS.CURRENT' | translate}}</h2>
            <button mat-icon-button matTooltip="{{'GESTORSTATUS.STATUS.TOOLTIP.HELP' | translate}}" (click)="infoStatusMsg()">
              <mat-icon matSuffix class="secondary-text">help</mat-icon>
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>

        <ng-container *ngFor="let paso of pasosWizard; last as last">
          <div *ngIf="paso.visible" class="pl-20 pr-20" fxLayout="row" fxLayoutAlign="space-between center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <h4 fxFlex="70">{{paso.titulo | translate}}</h4>
            <mat-slide-toggle (change)="cambioSlider($event)" [checked]="paso.completado" [disabled]="!paso.activo" fxFlex="10" matTooltip="{{'GESTORSTATUS.STATUS.TOOLTIP.SLIDER' | translate}}"></mat-slide-toggle>
            <h4 class="secondary-text" fxFlex="20">{{paso.textoStatus | translate}}</h4>
          </div>
          <mat-divider *ngIf="!last && paso.visible"></mat-divider>
        </ng-container>

      </div>
    </div>
  </ng-container>
</div>
